import i18n from '@/lib/i18n'

/**
 * F-143: the 409 `SENDING_SUSPENDED` of Campaigns and Workflows, said with
 * the end date in the community's time zone (the API's own message writes it
 * in UTC). The zone is set by the reputation banner, which every team page
 * renders.
 */
let zone: string | undefined
export const setSendingZone = (next: string | undefined | null) => { zone = next || undefined }

interface SuspensionData { code?: string; sendingSuspendedUntil?: string | null; untilLifted?: boolean; reason?: string | null }

export const sendingSuspensionOf = (e: unknown): SuspensionData | null => {
  const data = (e as { response?: { data?: { data?: SuspensionData } } })?.response?.data?.data
  return data?.code === 'SENDING_SUSPENDED' ? data : null
}

export const formatSendingDate = (iso: string): string => {
  try {
    return new Intl.DateTimeFormat(i18n.language, { dateStyle: 'medium', timeStyle: 'short', ...(zone ? { timeZone: zone } : {}) }).format(new Date(iso))
  } catch {
    return new Date(iso).toLocaleString()
  }
}

/** The message for that 409, or null for any other error. */
export const sendingSuspendedMessage = (e: unknown): string | null => {
  const s = sendingSuspensionOf(e)
  if (!s) return null
  return s.untilLifted || !s.sendingSuspendedUntil
    ? i18n.t('common:sendingReputation.refusedUntilLifted')
    : i18n.t('common:sendingReputation.refused', { when: formatSendingDate(s.sendingSuspendedUntil) })
}
